import React from 'react';
import { AdvancedRealTimeChart } from 'react-ts-tradingview-widgets';

type Props = { baseCurrency: string; exchangeCurrency: string };

export const CryptoExchangeRateWidget = ({ baseCurrency, exchangeCurrency }: Props) => {
    return <AdvancedRealTimeChart autosize symbol={`${exchangeCurrency}${baseCurrency}`} />;
};
